export enum DAPStatusEnum {
    DAP_CONSENT_IN_PROGRESS = "DAPConsentInProgress",
    DAP_DONE = "DAPDone",
    SECOND_CONSENT_REQUIRED = "SecondConsentRequired",
    OTHER_PERSONAL_DATA_COLLECTION_IN_PROGRESS = "OtherPersonalDataCollectionInProgress",
    DONE = "Done",
    FAILED = "Failed",
    UNEXPECTED_ERROR = "UnexpectedError",
    NO_SUBSCRIBER_FOUND = "NoSubscriberFound",
    //custom errors
    DAP_ERROR = "DAP_ERROR",
    GENERAL_ERROR = "GENERAL_ERROR",
}